import { Link } from "react-router-dom";
import Seo from "./Seo";

/** Minimal wrapper for static legal/content pages. */
export default function LegalLayout({ title, path, description, overline, children }) {
  return (
    <div className="min-h-screen bg-background grain relative">
      <Seo title={title} path={path} description={description} />
      <header className="relative z-10 border-b border-zinc-800">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <div className="w-8 h-8 border border-[#00D4FF] rotate-45 flex items-center justify-center">
              <span className="-rotate-45 text-[#00D4FF] font-mono text-xs font-bold">M</span>
            </div>
            <div>
              <div className="font-display text-lg leading-none">Martingale</div>
              <div className="overline leading-none mt-1">PLAYBOOK·TERMINAL</div>
            </div>
          </Link>
          <Link
            to="/"
            className="text-xs mono uppercase tracking-widest text-zinc-400 hover:text-[#00D4FF]"
          >
            ← Home
          </Link>
        </div>
      </header>

      <main className="relative z-10 max-w-4xl mx-auto px-6 lg:px-10 py-14">
        <div className="overline mb-3">{overline}</div>
        <h1 className="font-display text-4xl lg:text-5xl leading-tight mb-10">{title}</h1>
        <div className="prose prose-invert max-w-none space-y-6 text-zinc-300 leading-relaxed">
          {children}
        </div>
      </main>

      <footer className="relative z-10 border-t border-zinc-800 py-10">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 flex flex-wrap justify-between gap-4 text-xs mono text-zinc-500">
          <div>© 2026 MARTINGALE PLAYBOOK</div>
          <div className="flex gap-4">
            <Link to="/terms" className="hover:text-[#00D4FF]">Terms</Link>
            <Link to="/privacy" className="hover:text-[#00D4FF]">Privacy</Link>
            <Link to="/responsible-gambling" className="hover:text-[#00D4FF]">Responsible Gambling</Link>
            <Link to="/contact" className="hover:text-[#00D4FF]">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
